var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#0190D8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 23,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 33,
    height: 5,
    rx: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33v33H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniMenuIcon);
export default __webpack_public_path__ + "static/media/mini-menu-icon.46be228522b9ee578aed17480041a5c2.svg";
export { ForwardRef as ReactComponent };